(function () {
  if (window.__tcHomeInit) return;
  window.__tcHomeInit = true;

  /* Quick add to cart: uses Shopify AJAX cart + Envy cart drawer events. Falls back to normal form post. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-tc-quick-add]')) return;
    if (!window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-adding') || 'Adding…'; }
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Could not add');
        var bus = window.eventBus;
        if (bus && document.querySelector('cart-drawer')) {
          if (res.j.sections && res.j.sections['cart-drawer']) {
            bus.emit('update:cart:drawer', { sections: res.j.sections });
          } else {
            bus.emit('render:cart:drawer');
          }
          bus.emit('open:cart:drawer', { scrollToTop: true });
        } else {
          window.location.href = root + 'cart';
          return;
        }
        fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
          document.querySelectorAll('[data-cart-count], .cart-count, [data-cart-item-count]').forEach(function (el) { el.textContent = c.item_count; });
          document.dispatchEvent(new CustomEvent('cart:add', { detail: { cart: c } }));
        }).catch(function () {});
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
      })
      .catch(function () {
        form.removeAttribute('data-tc-quick-add');
        form.submit();
      });
  });

  /* Mobile sticky CTA: visible after the hero, hidden while the product grid is on screen */
  function initSticky() {
    var sticky = document.querySelector('[data-tc-sticky]');
    var hero = document.querySelector('[data-tc-hero]');
    if (!sticky || !hero || !('IntersectionObserver' in window)) return;
    var target = document.querySelector(sticky.getAttribute('data-target') || '#tc-best');
    var heroVis = true, targetVis = false;
    var upd = function () {
      var on = !heroVis && !targetVis;
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
    };
    new IntersectionObserver(function (en) { heroVis = en[0].isIntersecting; upd(); }).observe(hero);
    if (target) new IntersectionObserver(function (en) { targetVis = en[0].isIntersecting; upd(); }, { threshold: 0.15 }).observe(target);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky); else initSticky();
  document.addEventListener('shopify:section:load', initSticky);
})();

/* Collection filters: auto-apply sort + checkbox changes, drop empty price fields */
(function () {
  if (window.__tcFiltersInit) return;
  window.__tcFiltersInit = true;
  function clean(form) {
    form.querySelectorAll('.tc-price-range input').forEach(function (i) { if (i.value === '') i.disabled = true; });
  }
  document.addEventListener('change', function (e) {
    var form = e.target.closest && e.target.closest('form[data-tc-filters]');
    if (!form) return;
    if (e.target.matches('select[name="sort_by"], input[type="checkbox"]')) { clean(form); form.submit(); }
  });
  document.addEventListener('submit', function (e) {
    if (e.target.matches && e.target.matches('form[data-tc-filters]')) clean(e.target);
  }, true);
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.tc-filter[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('toggle', function (e) {
    if (e.target.matches && e.target.matches('.tc-filter') && e.target.open) {
      document.querySelectorAll('.tc-filter[open]').forEach(function (d) { if (d !== e.target) d.removeAttribute('open'); });
    }
  }, true);
})();

/* Product recommendations: fetch section HTML */
(function () {
  function load(el) {
    if (el.dataset.loaded || !el.dataset.url || !window.fetch) return;
    el.dataset.loaded = '1';
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var fresh = tmp.querySelector('[data-tc-recs]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  }
  function init() { document.querySelectorAll('[data-tc-recs]').forEach(load); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Card buy box: size, quantity, one-time vs subscribe, live price on the button */
(function () {
  if (window.__tcBuyInit) return;
  window.__tcBuyInit = true;
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var n = cents / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cur, minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(n);
    } catch (e) { return '$' + (n % 1 ? n.toFixed(2) : n); }
  }
  function data(form) {
    if (!form.__tc) {
      var el = form.querySelector('[data-tc-buy-json]');
      try { form.__tc = JSON.parse(el.textContent); } catch (e) { form.__tc = { variants: [] }; }
    }
    return form.__tc;
  }
  function update(form) {
    var d = data(form);
    var idEl = form.querySelector('[data-tc-variant]');
    var size = form.querySelector('[data-tc-size]');
    if (size) idEl.value = size.value;
    var v = d.variants.filter(function (x) { return String(x.id) === String(idEl.value); })[0] || d.variants[0];
    if (!v) return;
    var qtyEl = form.querySelector('[data-tc-qty-input]');
    var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    var wrap = form.querySelector('[data-tc-plans-wrap]');
    var freqWrap = form.querySelector('[data-tc-freq-wrap]');
    var freq = form.querySelector('[data-tc-freq]');
    var planEl = form.querySelector('[data-tc-plan]');
    var price = v.price;
    if (wrap) {
      var plans = v.plans || [];
      wrap.hidden = !plans.length;
      var save = form.querySelector('[data-tc-save]');
      if (save) {
        var pct = plans.length ? Math.round((1 - plans[0].price / v.price) * 100) : 0;
        save.textContent = pct > 0 ? '· Save ' + pct + '%' : '';
      }
      var sub = plans.length && form.querySelector('[data-tc-type][value="sub"]').checked;
      if (freq) {
        var key = v.id + ':' + plans.map(function (p) { return p.id; }).join(',');
        if (freq.dataset.key !== key) {
          var prev = freq.selectedIndex > -1 ? freq.options[freq.selectedIndex].text : '';
          freq.innerHTML = '';
          plans.forEach(function (p) {
            var o = document.createElement('option');
            o.value = p.id; o.textContent = p.label.replace(/^Deliver /, 'Delivered ');
            if (o.textContent === prev) o.selected = true;
            freq.appendChild(o);
          });
          freq.dataset.key = key;
        }
      }
      if (freqWrap) freqWrap.hidden = !sub;
      if (sub) {
        var chosen = plans.filter(function (p) { return String(p.id) === String(freq.value); })[0] || plans[0];
        planEl.disabled = false; planEl.value = chosen.id; price = chosen.price;
      } else {
        planEl.disabled = true; planEl.value = '';
      }
    }
    var btn = form.querySelector('.tc-buy__btn');
    var priceEl = form.querySelector('[data-tc-price]');
    if (priceEl) priceEl.textContent = money(price * qty);
    if (btn) btn.disabled = !v.available;
  }
  document.addEventListener('change', function (e) {
    var form = e.target.closest && e.target.closest('form[data-tc-buy]');
    if (form) update(form);
  });
  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('[data-tc-qty-input]')) update(e.target.closest('form[data-tc-buy]'));
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-tc-qty]');
    if (!b) return;
    var form = b.closest('form[data-tc-buy]');
    var input = form.querySelector('[data-tc-qty-input]');
    input.value = Math.min(99, Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-tc-qty'), 10)));
    update(form);
  });
  function init(root) { (root || document).querySelectorAll('form[data-tc-buy]').forEach(update); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  new MutationObserver(function (m) {
    m.forEach(function (r) { r.addedNodes.forEach(function (n) { if (n.nodeType === 1 && n.querySelector && n.querySelector('form[data-tc-buy]')) init(n); }); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
